module.exports = require("swa-bootstrap-corporate-landing-home-page/update-content-data");